(function () {

    angular
        .module('smartertoolsApp')
        .controller('myAccountController',
            [
                '$q', '$scope', '$log', '$timeout', 'myAccountService', 'partnerService', 'cacheControl', '$window', '$state', 'authenticationService', '$rootScope',
                myAccountController
            ]);

    function myAccountController($q, $scope, $log, $timeout, myAccountService, partnerService, cacheControl, $window, $state, authenticationService, $rootScope) {
        const vm = this;
        vm.isLoading = 0;
        vm.isLoggedIn = myAccountService.isLoggedIn;
        vm.areaPermissions = {};
        vm.notifications = {};
        vm.partnerInfo = null;
        vm.canAssignResellerLicenses = false;
        vm.canStartLeases = false;
        vm.hookAdded = false;
        vm.$state = $state;

        // Functions
        vm.clearCacheAndReloadPage = clearCacheAndReloadPage;
        vm.showLoginOverlay = showLoginOverlay;
        vm.calculatePartnershipVars = calculatePartnershipVars;
        vm.refresh = refresh;
        vm.generateNewAuthKey = generateNewAuthKey;
        vm.showGenerateNewAuthKeyModal = showGenerateNewAuthKeyModal;

        activate();

        // -----------------------------------------------

        function activate() {
            refresh();

            $rootScope.$on('myAccountService:changed', function (event, data) {
                refresh();
            });
        }

        function clearCacheAndReloadPage() {
            cacheControl.clearAllCaches();
            $window.location.reload();
        }

        function showLoginOverlay() {
            ShowLoginOverlay(function () {
            });
        }

        function calculatePartnershipVars() {
            const pi = vm.partnerInfo;

            vm.isActiveReseller = pi.Reseller && pi.Reseller.IsActive;
            vm.isInactiveReseller = pi.Reseller && !pi.Reseller.IsActive;
            vm.canAssignResellerLicenses = (vm.isActiveReseller || vm.isInactiveReseller) && vm.areaPermissions.PartnerReseller;
            vm.isSuspendedReseller = pi.Reseller && pi.Reseller.IsSuspended;

            vm.isActiveLeaseProvider = pi.LeaseProvider && pi.LeaseProvider.IsActive;
            vm.isInactiveLeaseProvider = pi.LeaseProvider && !pi.LeaseProvider.IsActive;
            vm.canStartLeases = vm.isActiveLeaseProvider && vm.areaPermissions.PartnerLeases;
            vm.isSuspendedLeaseProvider = pi.LeaseProvider && pi.LeaseProvider.IsSuspended;

            vm.isActiveHighAvailabilityPartner = pi.HighAvailabilityPartner && pi.HighAvailabilityPartner.IsActive;
            vm.isInactiveHighAvailabilityPartner = pi.HighAvailabilityPartner && !pi.HighAvailabilityPartner.IsActive;
            vm.isSuspendedHighAvailabilityPartner = pi.HighAvailabilityPartner && pi.HighAvailabilityPartner.IsSuspended;
        }

        function showGenerateNewAuthKeyModal() {
            bootstrap.Modal.getOrCreateInstance(document.getElementById('generate-auth-key-modal')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function generateNewAuthKey() {
            partnerService.generateNewAuthKeyPromise().then(() => {
                bootstrap.Modal.getOrCreateInstance(document.getElementById('generate-auth-key-modal')).hide();
                clearCacheAndReloadPage();
            });
        }

        function refresh() {
            vm.isLoading++;

            $q
                .all([
                    myAccountService.getAreaPermissions(),
                    partnerService.getPartnershipDetails()
                ])
                .then(arr => {
                    let data = arr[0];
                    vm.areaPermissions = data.Sections;
                    vm.notifications = data.Notifications;

                    data = arr[1];
                    vm.partnerInfo = data;
                    vm.calculatePartnershipVars();

                    vm.isLoading--;
                })
                .catch(err => {
                    if (err === 'No Refresh Token')
                        vm.isLoggedIn = false;
                    else
                        vm.loadingError = 'There was a problem loading this information.  Please try again later.';
                    vm.isLoading--;
                });
        }
    }

})();